<template>
  <div>
    <transition name="el-fade-in-linear">
      <div class="index">
        <div class="block">
          <el-carousel
            :height="hdgd"
            :autoplay="false"
            direction="vertical"
            ref="changeCard0"
          >
            <el-carousel-item v-for="item in 7" :key="item" name="item">
              <div v-if="item == 1">
                <div class="secondBlock">
                  <el-carousel ref="changeCard" height="800px">
                    <div class="lineLayout">
                      <div class="line" ></div>
                      <div class="lineShort"></div>
                      <br />
                      <div class="spanTextItem" @click="changePic($event, 0)">
                        01
                      </div>
                      <div class="spanTextItem" @click="changePic($event, 1)">
                        02
                      </div>
                      <div class="spanTextItem" @click="changePic($event, 2)">
                        03
                      </div>
                    </div>

                    <div class="textIndexShow">
                      <div class="layoutFlexItem2">
                        <img
                          class="layoutFlexItemImg"
                          src="../../static/images/indexPic2.png"
                        />
                      </div>
                      <div class="layoutFlexItem1">
                        <div class="layoutFlexText">智能决策引擎</div>
                        <img
                          class="layoutFlexText"
                          src="../../static/images/indexText1.png"
                        />
                      </div>
                      <div class="layoutFlexItem3">
                        <div class="layoutFlexText1">
                          以大数据为核心，融合物联网，人工智能，人脸识别，地图引擎等先进技术构建一体化的技术能力平台。
                        </div>
                      </div>
                    </div>

                    <div class="textIndexShow" style="display: none">
                      <div class="layoutFlexItem4">
                        <img src="../../static/images/indexPic1.png" class="indexPic1Item4" />
                      </div>
                      <div class="layoutFlexItem5">
                        <div class="layoutFlexText3">大交通领域决策</div>
                        <div class="layoutFlexText3">智能的领导者</div>
                      </div>
                    </div>

                    <div class="textIndexShow" style="display: none">
                      <div class="layoutFlexItem6">
                        <img src="../../static/images/indexPic3.png" class="indexPic3Item6"/>
                      </div>
                      <div class="layoutFlexItem5">
                        <div class="layoutFlexText3">
                          “公共交通一体化智慧监测系统”
                        </div>
                        <div class="layoutFlexText3">获得德国红点奖</div>
                      </div>
                    </div>

                    <el-carousel-item
                      v-for="item in 3"
                      :key="item"
                      name="item"
                      :autoplay="false"
                    >
                      <div v-if="item == 1" class="layoutFlex1">
                        <!--
                        <div class="layoutFlexItem2">
                          <img
                            class="layoutFlexItemImg"
                            src="../../static/images/indexPic2.png"
                          />
                        </div>
                        <div class="layoutFlexItem1">
                          <div class="layoutFlexText">智能决策引擎</div>
                          <img
                            class="layoutFlexText"
                            src="../../static/images/indexText1.png"
                          />
                        </div>
                        <div class="layoutFlexItem3">
                          <div class="layoutFlexText1">
                            以大数据为核心，融合物联网，人工智能，人脸识别，地图引擎等先进技术构建一体化的技术能力平台。
                          </div>
                        </div>
                        -->
                      </div>
                      <div v-if="item == 2" class="layoutFlex2">
                        <!--
                        <div class="layoutFlexItem4">
                          <img src="../../static/images/indexPic1.png" />
                        </div>
                        <div class="layoutFlexItem5">
                          <div class="layoutFlexText3">大交通领域决策</div>
                          <div class="layoutFlexText3">智能的领导者</div>
                        </div>
                        -->
                      </div>
                      <div v-if="item == 3" class="layoutFlex3">
                        <!--
                        <div class="layoutFlexItem6">
                          <img src="../../static/images/indexPic3.png" />
                        </div>
                        <div class="layoutFlexItem5">
                          <div class="layoutFlexText3">
                            “公共交通一体化智慧监测系统”
                          </div>
                          <div class="layoutFlexText3">获得德国红点奖</div>
                        </div>
                        -->
                      </div>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div v-if="item == 2" class="index2LayoutFlex">
                <div class="index2Item1">
                  <img src="../../static/images/indexText2.png" />
                </div>
                <div class="index2Item2">
                  <img src="../../static/images/indexPic4.png" />
                </div>
              </div>
              <div v-if="item == 3" class="index3LayoutFlex">
                <div class="index3Item0">
                  <img src="../../static/images/indexText3.png" />
                  <img src="../../static/images/indexPic5.png" />
                </div>
                <div class="index3Item3">
                  <img src="../../static/images/indexPic8.png" />
                </div>
                <div class="index3Item2">
                  <img src="../../static/images/indexPic6.png" />
                </div>
                <div class="index3Item4">
                  <img src="../../static/images/indexPic8.png" />
                </div>
                <div class="index3Item1">
                  <img src="../../static/images/indexPic7.png" />
                </div>
              </div>
              <div v-if="item == 4" class="index4LayoutFlex">
                <div class="index4Item0">
                  <img src="../../static/images/indexText4.png" />
                  <div class="index4ItemText">
                    北斗院深耕智能交通行业多年，打造了完整而先进的多种公共交通解决方案，包括智慧安防、智慧民航、智慧物流、智慧地铁、综合交通、智慧高速等，助推行业智能化升级与变革。
                  </div>
                </div>
                <div class="index4Item1">
                  <img
                    class="index4ItemPic"
                    src="../../static/images/indexPic9.png"
                  />
                  <div class="itemLayout">
                    <div class="selectItem" @click="goSolution(1)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem1.png"
                      />
                      <p class="selectItemText">综合交通行业解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(2)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem2.png"
                      />
                      <p class="selectItemText">智慧高速解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(3)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem3.png"
                      />
                      <p class="selectItemText">智慧安防解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(4)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem4.png"
                      />
                      <p class="selectItemText">智慧轨道解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(5)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem5.png"
                      />
                      <p class="selectItemText">智慧机场解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(6)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem6.png"
                      />
                      <p class="selectItemText">智慧物流解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(7)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem7.png"
                      />
                      <p class="selectItemText">智慧城市解决方案</p>
                    </div>
                    <div class="selectItem" @click="goSolution(8)">
                      <img
                        class="selectItemImg"
                        src="../../static/images/solutionItem8.png"
                      />
                      <p class="selectItemText">智慧园区解决方案</p>
                    </div>
                    <div class="selectItemAlter"></div>
                  </div>
                </div>
              </div>
              <div v-if="item == 5" class="index5LayoutFlex">
                <div class="index5Item0">
                  <img src="../../static/images/indexText5.png" />
                </div>

                <router-link class="index5Item0" to="/newsDetail1">
                  <img class="secondPic" src="../../static/images/newsPic1.png" />
                </router-link>
                <router-link class="index5Item1" to="/newsDetail1">
                  <div class="secondText">
                    地铁线路拓展至10条 北斗院算法服务升级
                  </div>
                  <div class="secondTextTime">2020.08.23</div>
                  <img
                    class="secondTextPic"
                    src="../../static/images/arrowsRight.png"
                  />
                </router-link>

                <router-link class="index5Item0" to="/newsDetail">
                  <img class="secondPic" src="../../static/images/newsPic2.png" />
                </router-link>
                <router-link class="index5Item1" to="/newsDetail">
                  <div class="secondText">
                    2020爱分析知识图谱厂商报，北斗院榜上有名
                  </div>
                  <div class="secondTextTime">2020.08.11</div>
                  <img
                    class="secondTextPic"
                    src="../../static/images/arrowsRight.png"
                  />
                </router-link>
                <div class="index5Item0"></div>
                <router-link class="index5Item0" to="/newsDetail2">
                  <img class="secondPic" src="../../static/images/newsPic3.png" />
                </router-link>
                <router-link class="index5Item1" to="/newsDetail2">
                  <div class="secondText">
                    喜报！北斗院荣获智慧交通产业三大奖项
                  </div>
                  <div class="secondTextTime">2020.07.14</div>
                  <img
                    class="secondTextPic"
                    src="../../static/images/arrowsRight.png"
                  />
                </router-link>

                <router-link class="index5Item0" to="/newsDetail3">
                  <img class="secondPic" src="../../static/images/newsPic4.png" />
                </router-link>
                <router-link class="index5Item1" to="/newsDetail3">
                  <div class="secondText">
                    科研硬核 | 城市轨道交通，大客流安全管控如何破题?
                  </div>
                  <div class="secondTextTime">2020.04.14</div>
                  <img
                    class="secondTextPic"
                    src="../../static/images/arrowsRight.png"
                  />
                </router-link>
              </div>
              <div v-if="item == 6" class="index6LayoutFlex">
                    <img
                    class="index6Item1"
                    src="../../static/images/indexText7.png"
                  />
                  <img src="../../static/images/indexText6.png" class="indexText6" />
                  <div class="aboutSecondLevelTitle1">北斗院</div>
        <div class="aboutSecondLevelTitle2">深圳北斗应用技术研究院有限公司</div>
        <div class="aboutSecondLevelText">
          是中国科学院深圳先进技术研究院于2014年9月成立的面向人工智能应用领域的专业型研发机构。北斗院致力于打造大交通行业的智能决策引擎，通过融合大数据、人工智能等技术，贯通交通组织感知-认知-决策-反馈的自适应闭环，助推产业智能化升级，实现安全、高效、可持续发展。
        </div>
                  <br />
              </div>
              <div v-if="item == 7" class="index7LayoutFlex">
                <div class="index7Item0">
                  <img src="../../static/images/indexText8.png" />
                </div>
                <div class="index7Item1">
                  <img src="../../static/images/indexPic10.png" />
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </transition>
    <div class="copy-right">
      <div class="right">Copyright©2020-2030深圳北斗应用技术研究院有限公司,保留所有权利  <span style="cursor: pointer;" @click="toGov">{{ copyright }}</span></div>
    </div>
  </div>

</template>


<script>
export default {
  name: "Index",
  data() {
    return {
      hdgd:'800px',
      lineWdith:'930',
      index: 1,
      height: 0,
      copyright: '粤ICP备15028556号-2'
    };
  },
  components: {
  },
  mounted() {
    this.scrollPic()
    this.fixHeightSize()
    if(window.location.host === 'openxdata.cn'){
      this.copyright = '粤ICP备15028556号-1';
    }else{
      this.copyright = '粤ICP备15028556号-2';
    }
  },
  methods: {
    toGov(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index');
    },
     scrollPic(){
      //初始化标签
      let i, tablinks;
      tablinks = document.getElementsByClassName("spanTextItem");
      tablinks[0].className += " active";
      //evt.currentTarget.className += " active";
      //返回都控制到页头
      this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0);
      });
      window.addEventListener("mousewheel", this.handleScroll, false);
     },
    fixHeightSize(){
        let that = this;
        window.onresize = function windowResize() {
          // 通过捕获系统的onresize事件触发我们需要执行的事件
          var w = window.innerWidth
          var h = 800
          if (w > 1920) {
            h = 800
            that.lineWdith =  '930'
              
          } else {
            h = 0.416 * w
            that.lineWdith =(parseInt(0.484 * w,10)).toString();
          }
          that.hdgd = parseInt(h,10)  + 'px'
          // console.log('window.innerWidth',window.innerWidth)
          // console.log('that.hdgd',that.hdgd)
          // console.log('that.lineWdith',that.lineWdith)
        }
    },
    handleScroll(e) {
      var direction = e.deltaY > 0 ? "down" : "up"; //该语句可以用来判断滚轮是向上滑动还是向下
      let that = this;
      setTimeout(() => {
        if (direction === "down") {
          that.$refs.changeCard0.setActiveItem(that.index + 1);
          that.index = that.index + 1;
          if (that.index == 8) {
            that.index = 1;
          }
        } else {
          if (that.index == 1) {
            that.$refs.changeCard0.setActiveItem(7);
            that.index = 7;
          } else {
            that.$refs.changeCard0.setActiveItem(that.index - 1);
            that.index = that.index - 1;
          }
        }
      }, 10);
    },
    openCity(evt, path) {
      let i, tabcontent, tablinks, line;
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      evt.currentTarget.className += " active";
    },
    changePic: function (evt, index) {
      this.$nextTick(function () {
        this.$refs.changeCard[0].setActiveItem(index);
        this.index = index;
      });

      let i, tabcontent, tablinks;
      tablinks = document.getElementsByClassName("spanTextItem");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      evt.currentTarget.className += " active";

      let textIndexShow = document.getElementsByClassName("textIndexShow");
      for (i = 0; i < textIndexShow.length; i++) {
        if (i != index) {
          textIndexShow[i].style.display = "none";
        } else {
          textIndexShow[i].style.display = "inline";
        }
      }
    },
    goDetail: function () {
      this.$router.push({
        path: "newsDetail",
      });
    },
    goSolution: function (index) {
      //console.log("index", index);
      this.$router.push({
        path: "solution",
        query: { index: index },
      });
    },
  },
};
</script>
<style scoped>
@import "./Index.css";
@import "./Foot.css";
</style>



// WEBPACK FOOTER //
// src/views/Index.vue